var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[(_vm.params.data.CheckinType == 'Both')?_c('span',[_vm._v("Self & Group")]):(_vm.params.data.CheckinType == 'Remote')?_c('span',[_vm._v("Private")]):_c('span',[_vm._v(_vm._s(_vm.params.data.CheckinType))])])
}
var staticRenderFns = []

export { render, staticRenderFns }